/**
 * Created by vladislav on 07.06.2021
 */

const SafeCardView = CardView.extend({
    ctor: function (card) {
        this._super(card, {
            animation_json: bundles.card.jsons.safe_card_json
        });

        const styles = cleverapps.styles.SafeCardView;
        this.setContentSize2(styles);

        this.animation.setAlignment(styles.animation);
        this.animation.setAnimation(0, "idle_close_suit_value", true);

        this.card.on("openSuit", this.createListener(this.openSuit.bind(this)));
        this.card.on("openValue", this.createListener(this.openValue.bind(this)));
        this.card.on("openValueAndSuit", this.createListener(this.openValueAndSuit.bind(this)));
        this.card.on("openSafe", this.createListener(this.openSafe.bind(this)));
        this.card.on("spawn", this.createListener(this.spawn.bind(this)));

        if (!cleverapps.environment.isAdministratorScene() && !cleverapps.environment.isEditorScene()) {
            cleverapps.UI.onPressed(this, card.onClickListener.bind(card, card));
            cleverapps.UI.applyHover(this);
        }

        if (cleverapps.environment.isEditorScene()) {
            this.addEditorButtons();
        }
    },

    setIdleAnimation: function () {
        let idleAnimation = "idle_close_suit_value";
        if (this.card.suitOpened) {
            idleAnimation = "idle_value";
        }
        if (this.card.suitOpened) {
            idleAnimation = "idle_suit";
        }
        this.animation.setAnimation(0, idleAnimation, true);
    },

    fitAnimationScale: function () {
        const scale = SafeCard.WIDTH * resolutionScale / this.animation.width;
        this.animation.setScale(scale);
    },

    spawn: function (card) {
        const styles = cleverapps.styles.SafeCardView;

        const ViewClass = card.getViewClass();
        const view = new ViewClass(card);
        this.addChild(view);
        view.setAlignment(styles.wildcard);
    },

    openSuit: function (card) {
        this.runCardAnimation(card, () => {
            if (this.card.valueOpened) {
                this.animation.setAnimation(0, "open_value_suit", false);
            } else {
                this.animation.setAnimationAndIdleAfter("open_suit", "idle_suit");
            }
        });
    },

    openValue: function (card) {
        this.runCardAnimation(card, () => {
            if (this.card.suitOpened) {
                this.animation.setAnimation(0, "open_suit_value", false);
            } else {
                this.animation.setAnimationAndIdleAfter("open_value", "idle_value");
            }
        });
    },

    openValueAndSuit: function (card) {
        this.runCardAnimation(card, () => {
            this.animation.setAnimation(0, "open_both", false);
        });
    },

    runCardAnimation: function (card, callback) {
        const scene = cleverapps.Scenes.GetRunningScene();
        const cardView = card.onGetView();
        cardView.replaceParentSamePlace(cleverapps.Scenes.GetMovingNode());
 
        const position = cleverapps.Scenes.GetMovingNode().convertToNodeSpace(this.convertToWorldSpace(cc.p(this.width / 2, this.height / 2)));
        const offScenePosition = cleverapps.Scenes.GetMovingNode().convertToNodeSpace(cc.p(scene.width / 2, scene.height + cardView.height));
        cardView.runAction(new cc.Sequence(
            cleverapps.effects.fireAction("solitaire.safe.collect"),
            new cc.MoveTo(SafeCard.FLY_TIME / 1000, position).easing(cc.easeIn(2)),
            new cc.CallFunc(callback),
            new cc.Spawn(
                new cc.RotateBy(0.4, 360),
                new cc.MoveTo(0.4, offScenePosition)
            ),
            new cc.RemoveSelf()
        ));
    },

    openSafe: function () {
        this.animation.setAnimation(0, "safe_open", false);
        cleverapps.effects.fire("solitaire.safe.open");
        this.animation.setCompleteListener(() => {
            this.animation.setAnimation(0, "safe_close", false);
            this.animation.setCompleteListener(() => {
                this.runAction(new cc.Sequence(
                    new cc.ScaleTo(0.3, 0),
                    new cc.RemoveSelf()
                ));
            });
        });
    },

    onFlip: function () {
    }
});

if (cleverapps.config.debugMode) {
    SafeCardView.prototype.addEditorButtons = function () {
        const styles = cleverapps.styles.SafeCardView;

        const buttons = [
            function () {
                this.card.requiredValue = (this.card.requiredValue + 1) % Card.VALUES.length;
                this.animation.setSkin(`${Card.VALUES[this.card.requiredValue]}_${this.card.requiredSuit}`);
                Editor.currentEditor.save();
            }.bind(this),
            function () {
                this.card.requiredSuit = Card.SUITS[(Card.SUITS.indexOf(this.card.requiredSuit) + 1) % Card.SUITS.length];
                this.animation.setSkin(`${Card.VALUES[this.card.requiredValue]}_${this.card.requiredSuit}`);
                Editor.currentEditor.save();
            }.bind(this)
        ].map((func) => {
            const button = new cc.Node();
            button.setAnchorPoint(0.5, 0.5);
            button.setContentSize2(styles.editorButtons);
            cleverapps.UI.onClick(button, func);
            return button;
        });

        const layout = new cleverapps.Layout(buttons, {
            margin: styles.editorButtons.margin,
            direction: cleverapps.UI.HORIZONTAL
        });
        this.addChild(layout);
        layout.setAlignment(styles.editorButtons);
        layout.setLocalZOrder(10);
    };
}

cleverapps.styles.SafeCardView = {
    width: 300,
    height: 300,

    animation: {
        x: { align: "center", dx: -10 },
        y: { align: "center", dy: -10 }
    },

    wildcard: {
        x: { align: "center", dx: -10 },
        y: { align: "center", dy: 9 }
    },

    editorButtons: {
        width: 60,
        height: 120,
        margin: 15,
        x: { align: "center" },
        y: { align: "center", dy: -5 }
    }
};